import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import RowMenu from '../../components/row_menu'
import { Trash } from '@phosphor-icons/react'
import { Button, Badge, EmptyState } from '@cinesend/ui-kit'
import DataTable from '../../components/data_table'
import Page from '../../components/layouts/page'
import useStore from '../../hooks/use_store'
import { useNavigate } from 'react-router-dom'

const Airlines = () => {
  const { createModel, deleteModel } = useStore()
  const [search, setSearch] = useState('')
  const { data: cycleFrequencies } = useQuery({ queryKey: ['/api/cycle-frequencies'] })
  const { data: airlines, error, isLoading, refetch } = useQuery(['airlines', `?search=${search}`])
  const navigate = useNavigate()
  const columns = [
    { key: 'name', header: 'Name', render: (data) => data.name },
    { key: 'group_code', header: 'Group code', render: (data) => data.group_code },
    {
      key: 'languages',
      header: 'Portal Languages',
      render: (data) =>
        data.languages ? (
          <div className='flex space-x-2'>
            {data.languages.map((opt) => (
              <Badge key={opt.id}>{opt.eng_description.toUpperCase()}</Badge>
            ))}
          </div>
        ) : null,
    },
    {
      key: 'cycle_frequency',
      header: 'Cycle Frequency',
      render: (data) => (
        <Badge tone='warning'>
          {(
            cycleFrequencies?.find((v) => v.value === data.cycle_frequency)?.label ?? data.cycle_frequency
          ).toUpperCase()}
        </Badge>
      ),
    },
    {
      key: 'actions',
      header: '',
      width: '65px',
      render: (data) => (
        <RowMenu
          label={`Actions for ${data.name}`}
          items={[
            {
              id: 'delete',
              label: 'Delete',
              tone: 'danger',
              icon: <Trash size={20} />,
              onSelect: () =>
                deleteModel.mutate({
                  endpoint: 'airlines',
                  id: data.id,
                  deleteNoun: 'airline',
                  deleteName: data.name,
                }),
            },
          ]}
        />
      ),
    },
  ]

  return (
    <Page
      title={'Airlines'}
      buttons={[
        <Button
          key={'Airlines'}
          disabled={createModel.isLoading}
          onClick={() =>
            createModel.mutate(
              { endpoint: 'airlines', data: { name: 'New Airline', cycle_frequency: 'monthly' } },
              {
                onSuccess: (res) => {
                  navigate(`${res.data.airline.id}`)
                },
              }
            )
          }
        >
          Create airline
        </Button>,
      ]}
    >
      <DataTable
        caption='Airlines'
        columns={columns}
        rows={airlines ?? []}
        onRowClick={(data) => navigate(`${data.id}`)}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
        empty={<EmptyState title='No airlines found!' detail='Create a new airline to begin.' />}
        searching={{ search, onSearch: setSearch }}
      />
    </Page>
  )
}

export default Airlines
